"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.GeolocationCondition = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var GeolocationCondition = /*#__PURE__*/function () {
  function GeolocationCondition(a) {
    _classCallCheck(this, GeolocationCondition);
    var b = a.country,
      c = a.region,
      d = a.city;
    _defineProperty(this, "country", void 0), _defineProperty(this, "region", void 0), _defineProperty(this, "city", void 0), this.country = b, this.region = c, this.city = d;
  }
  return _createClass(GeolocationCondition, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      var c = null === b || void 0 === b ? void 0 : b[_kameleoonData.KameleoonData.GeolocationData];
      if (c) {
        var _a = c.country,
          _b = c.region,
          d = c.city,
          _ref = [this.country, this.region, this.city],
          e = _ref[0],
          f = _ref[1],
          g = _ref[2];
        if (!e || !_a) return (0, _tsRes.Ok)(!1);
        var h = _a.toLowerCase() === e.toLowerCase() && (!f || (null === _b || void 0 === _b ? void 0 : _b.toLowerCase()) === f.toLowerCase()) && (!g || (null === d || void 0 === d ? void 0 : d.toLowerCase()) === g.toLowerCase());
        return (0, _tsRes.Ok)(h);
      }
      return (0, _tsRes.Ok)(!1);
    }
  }]);
}();
exports.GeolocationCondition = GeolocationCondition;